import { centroid } from "@turf/turf";
import { AreaData } from "../api/api";


export function renderAreas(allAreas: AreaData[], show: boolean, map: maplibregl.Map) {
    // make sure map has loaded before calling this function

    map.getLayer('area-labels') && map.removeLayer('area-labels');
    map.getLayer('area-fills') && map.removeLayer('area-fills');
    map.getLayer('area-outlines') && map.removeLayer('area-outlines');
    map.getSource('area-source') && map.removeSource('area-source');
    map.getSource('area-point-source') && map.removeSource('area-point-source');

    if (!show){
        return;
    }

    map.addSource('area-source', {
        type: 'geojson',
        data: {
            'type': 'FeatureCollection',
            'features': allAreas.map(area => ({ type: "Feature", properties: {}, geometry: area.Geometry }))
        }
    });

    map.addSource('area-point-source', {
        type: 'geojson',
        data: {
            'type': 'FeatureCollection',
            'features': allAreas.map(area => ({ type: "Feature", properties: { 'name': area.Name || '' }, geometry: centroid(area.Geometry).geometry }))
        }
    });

    map.addLayer({
        id: `area-fills`,
        type: 'fill',
        source: `area-source`,
        paint: {
            'fill-color': '#888888',
            'fill-opacity': 0.5
        }
    });

    map.addLayer({
        id: `area-outlines`,
        type: 'line',
        source: `area-source`,
        paint: {
            'line-color': '#000000',
            'line-width': 2
        }
    });

    map.addLayer({
        'id': 'area-labels',
        'type': 'symbol',
        'source': 'area-point-source',            
        'minzoom': 14,
        'layout': {
            'text-field': ['get', 'name'],
            'text-font': ['Noto Sans Regular'],
            'text-size': 16,
        }
    });
}